import axios from "axios";
import Cookies from 'js-cookie';

const apiUrl = process.env.REACT_APP_API_URL;

const service = axios.create({
	baseURL: apiUrl,
	timeout: 60000,
});

service.interceptors.request.use(
	(config) => {
		const token = Cookies.get('token');

		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}

		return config;
	},
	(error) => {
		return Promise.reject(error);
	},
);

service.interceptors.response.use(
	(response) => {
		return response.data;
	},
	(error) => {
		return Promise.reject(error);
	},
);

export default service;